/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./boost.vue?vue&type=template&id=50b49fba&scoped=true"
import script from "./boost.vue?vue&type=script&lang=js"
export * from "./boost.vue?vue&type=script&lang=js"
import style0 from "./boost.vue?vue&type=style&index=0&id=50b49fba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b49fba",
  null
  
)

export default component.exports